import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, AlertTriangle, CheckCircle2, Users } from 'lucide-react';
import { RESULT_CONTENT, MetabolicType } from '../lib/constants';
interface ResultsPageProps {
  resultType: MetabolicType;
  onContinue: () => void;
}
export function ResultsPage({
  resultType,
  onContinue
}: ResultsPageProps) {
  const content = RESULT_CONTENT[resultType];
  useEffect(() => {
    window.scrollTo(0, 0);
    if ((window as any).fbq) {
      ;
      (window as any).fbq('track', 'ViewContent', {
        content_name: 'Resultado Quiz Metabolico',
        content_category: 'Quiz',
        content_type: 'product'
      });
    }
  }, []);
  return <motion.div initial={{
    opacity: 0,
    scale: 0.95
  }} animate={{
    opacity: 1,
    scale: 1
  }} exit={{
    opacity: 0
  }} className="flex flex-col items-center text-center px-5 pt-4 pb-6 min-h-[100dvh] bg-white max-w-md mx-auto shadow-xl overflow-y-auto hide-scrollbar relative" data-id="element-272">
      {/* Urgency banner */}
      <div className="w-full bg-yellow-400 text-dark py-2 px-3 rounded-xl mb-4 flex items-center justify-center gap-2" data-id="element-273">
        <AlertTriangle className="w-4 h-4" data-id="element-274" />
        <span className="text-xs font-black uppercase tracking-wide" data-id="element-275">
          Resultado listo — Lee con atención
        </span>
      </div>

      {/* Image */}
      <div className="w-full max-w-[200px] mx-auto mb-4 relative" data-id="element-276">
        <div className="absolute inset-0 bg-primary/20 blur-3xl rounded-full -z-10" data-id="element-277" />
        <img src={content.image} alt={content.title} className="w-full object-contain rounded-3xl shadow-2xl" data-id="element-278" />
      </div>

      {/* Title */}
      <h1 className="text-xl font-extrabold text-dark mb-1" data-id="element-279">
        Tu metabolismo es:
      </h1>
      <h2 className="text-4xl font-black text-primary uppercase tracking-wide mb-4" data-id="element-280">
        {content.title}
      </h2>

      {/* Warning */}
      <div className="bg-red-50 border-2 border-red-200 rounded-xl p-3 mb-3 w-full" data-id="element-281">
        <p className="text-red-800 font-bold text-sm leading-relaxed" data-id="element-282">
          ⚠️ Tu metabolismo <span className="uppercase" data-id="element-283">{content.title}</span>{' '}
          explica{' '}
          <span className="underline decoration-2" data-id="element-284">
            POR QUÉ no has podido bajar de peso
          </span>
          .
        </p>
      </div>

      {/* Hype content — fill the space */}
      <div className="w-full space-y-3 mb-4" data-id="element-285">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} className="bg-dark text-white rounded-xl p-3 text-left" data-id="element-286">
          <p className="text-xs font-bold leading-relaxed" data-id="element-287">
            El <span className="text-yellow-400" data-id="element-288">87% de las personas</span> con
            metabolismo{' '}
            <span className="uppercase text-yellow-400" data-id="element-289">{content.title}</span>{' '}
            siguen una dieta que los hace ENGORDAR más. Tú podrías ser una de
            ellas.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.5
      }} className="flex items-center gap-2 bg-green-50 border border-green-200 rounded-xl p-3" data-id="element-290">
          <Users className="w-5 h-5 text-green-600 shrink-0" data-id="element-291" />
          <p className="text-xs text-green-800 font-bold text-left" data-id="element-292">
            +10,000 personas con tu mismo metabolismo ya transformaron su cuerpo
            con el plan correcto.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.7
      }} className="flex items-center gap-2 bg-blue-50 border border-blue-200 rounded-xl p-3" data-id="element-293">
          <CheckCircle2 className="w-5 h-5 text-blue-600 shrink-0" data-id="element-294" />
          <p className="text-xs text-blue-800 font-bold text-left" data-id="element-295">
            Lo que vas a descubrir a continuación puede cambiar tu vida. No es
            exageración.
          </p>
        </motion.div>
      </div>

      {/* CTA */}
      <motion.button whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} onClick={onContinue} className="w-full bg-green-600 text-white text-base font-black py-4 rounded-xl shadow-[0_5px_0_rgb(22,163,74)] active:shadow-[0_0px_0_rgb(22,163,74)] active:translate-y-[5px] transition-all flex items-center justify-center gap-2 shrink-0 uppercase tracking-tight mt-auto" data-id="element-296">
        ¿Ahora qué hago con esta información?
        <ArrowRight className="w-5 h-5 shrink-0" data-id="element-297" />
      </motion.button>
    </motion.div>;
}